<template>
	<div>
		<!-- swiper 插件 轮播图 -->
    <!-- swiper 插件 轮播图 -->
    <div class="banner">
      <img :src="pageData.banner" alt="">
      <div class="title">{{pageData.title}}</div>
    </div>

    <!-- 内容容器 -->
    <div class="content-wrapper">
      <section class="data0">
        <div class="content">
          <img src="../assets/images2/join_icon@2x.png" alt="">
          <div class="right" @click="openPage(pageData.data0.url)">
            <div class="title">{{pageData.data0.title}}</div>
            <div class="more-box">查看职位</div>
          </div>
        </div>
      </section>
			<section class="data4">
				<div class="content">
					<div v-for="(item, index) in pageData.data4.lists" :key="index" class="item" :class="{right: index%2==1&&!['xs'].includes(deviceType)}">
						<div class="img-box">
							<img :src="item.imgUrl" alt="">
						</div>
						<div class="text-box">
							<!-- <div class="title">{{item.title}}</div> -->
							<div class="sub_title">{{item.sub_title}}</div>
              <template>
                <div class="lists" >
                  <!-- <div class="descs">
                    <template v-for="(item, index) in handleBrArr(item.content)">
                      <div :key="index" class="item" v-if="item">
                        {{item}}
                      </div>
                    </template>
                  </div> -->
                  <div v-html="handleBrTag(item.content)"></div>

                </div>

              </template>
							<!-- <div class="lists" v-html="handleBrTag(item.content)"> -->
                <!-- <div>{{item.content}}</div> -->
								<!-- <div v-for="(detail, II) in item.lists" :key="II" class="detail">
									<span>{{II + 1}}</span>{{detail}}
								</div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>
			</section>
      <!-- data3 图片展示模块 -->
			<section class="data3">
				<div class="content">
					<div class="title border">{{pageData.data3.title}}</div>
					<div class="data3-swiper-box">
						<div class="data3-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item, index) in pageData.data3.lists" :key="index">
									<img :src="item.imgUrl" alt="">
								</div>
							</div>
						</div>
						<div class="swiper-button-prev swiper-btn swiper-left"></div>
						<div class="swiper-button-next swiper-btn swiper-right"></div>
					</div>
				</div>
			</section>
    </div>
	</div>
</template>

<script>
	import mixins from '@/mixins';
  import Swiper from 'swiper';
	import { bannerList, indexDataList, getAppInfo, itemList } from '@/utils/api';

	export default {
    name: 'Join',
    mixins: [mixins],
		props: {},
    data() {
      return {
        screenWidth: 0,
        screenHeight: 0,
        activeNav: 'join',
        pageData: {
          banner: '',
          title: '金融业智能化转型合作伙伴',
          data0: {
            title: '',
            url: ''
          },
          data4: {
            title: '在奔腾达',
            lists: []
          },
          data3: {
						title: '图片展示模块',
						lists: []
					},
        },
        data2Index: 0,
        serviceIndex: 0,
        dialogVisible: false,
        saving: false,
        formData: {},
        editRules: []
      };
    },
    components: {},
    created() {
			this.$store.commit('activeNav', 'join');
      this.init();
    },
    computed: {
      deviceType() {
        return this.$store.state.deviceType;
      },
    },
    mounted() {
      console.log('app--mounted--this.deviceType==', this.deviceType);

      this.data3Swipers = new Swiper('.data3-swiper', {
        autoplay: {
					delay: 5000,
					disableOnInteraction: false
        },
        observer: true,
        observeParents:true,
				navigation: {
					nextEl: '.data3-swiper-box .swiper-button-next',
					prevEl: '.data3-swiper-box .swiper-button-prev',
				},
			});
    },
    methods: {
      async init() {


        // title
        const res1 = await getAppInfo('key-join-title');
        this.pageData.title = res1.data.baseData.content;
        console.log('about--res1==', res1);
        const res1_2 = await getAppInfo('key-join-imgUrl');
        this.pageData.banner = res1_2.data.baseData.content;
        console.log('about--res1_2==', res1_2);


        // banner
        const res2 = await getAppInfo('key-join-imgUrl');
        this.pageData.banner = res2.data.baseData.content;
        console.log('join--res2==', res2);

        // key-join-m-job-title
        const res3 = await getAppInfo('key-join-m-job-title');
        this.pageData.data0.title = res3.data.baseData.content;
        console.log('join--res3==', res3);

        const res4 = await getAppInfo('key-join-m-job-url');
        this.pageData.data0.url = res4.data.baseData.content;
        console.log('join--res4==', res4);

        const res5 = await itemList({type: 7});
        this.pageData.data4.lists = res5.data.baseData || [];
        console.log('join--res5==', res5);


        const res6_1 = await getAppInfo('key-join-m-env-title');
        this.pageData.data3.title = res6_1.data.baseData.content;

        const res6 = await itemList({type: 8});
        this.pageData.data3.lists = res6.data.baseData || [];
        console.log('join--res6==', res6);

        this.$set(this, 'pageData', this.pageData);
        console.log('join--this.pageData==', this.pageData);
        
      },
      openPage(url) {
        console.log('openPage--url==', url);
				if (!url) {
					return;
				}
				window.location.href = url;
			},
      changeNav(item) {
        console.log('changeNav--item==', item);
        if (item.id === 'product') {
          // this.showProductMenu = !this.showProductMenu;
          this.showProductMenu = true;
        } else {
          this.showProductMenu = false;
        }
        this.activeNav = item.id;
        // this.$router.push({path: '/pages/product'})
      },
      changeServiceIndex(index) {
        this.serviceIndex = index;
      },
      handleOpen(e) {
        console.log('handleOpen--e==', e);
      },
      handleClose(e) {
        console.log('handleClose--e==', e);
      },
      visibleChange(bool) {
        console.log('visibleChange--bool==', bool);
        this.productList = this.productList.map(d => {
          d.open = false;
          return d;
        })
      },
      switchProduct(item, index) {
        console.log('switchProduct--item==', item);
        console.log('switchProduct--index==', index);
        console.log('switchProduct--this.productList==', this.productList);
        let row = JSON.parse(JSON.stringify(item));
        row.open = item.open ? false : true;
        this.$set(this.productList, index, row)
      },
      selProduct(e) {
        console.log('selProduct--e==', e);
      },
      handleSliceStr(str, start = 0, end) {
        var str1 = JSON.parse(JSON.stringify(str));
        if (!str) {
          return '';
        }
        if (!end || end > str.length) {
          end = str.length;
        }
        return str1.slice(start, end);
      },

      // changeData2Index(num) {
      //   const max = Math.ceil(this.pageData.data2.lists.length / 4);
      //   console.log('changeData2Index--max==', max);
        
      //   if (num > 0 && this.data2Index < max) {
      //     this.data2Index += num;
      //   } else if (num < 0 && this.data2Index > 0) {
      //     this.data2Index += num;
      //   }
      // }
    }
  
	}
</script>

<style scoped lang="scss">
@import '../common/css/join.scss';
</style>



// WEBPACK FOOTER //
// src/pages/join.vue